var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_PICKUP_RATE_REQUEST, fetchPickupRateFailure, fetchPickupRateSuccess } from '@/redux/actions';
import APILocal from '@/utils/APILocal';
const onPickUpRate = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APILocal.post(`cnvt/pickups/rates`, action.payload)
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* pickupRateWorker(action) {
    try {
        const data = yield call(onPickUpRate, action);
        yield put(fetchPickupRateSuccess(data));
    }
    catch (error) {
        yield put(fetchPickupRateFailure(error));
    }
}
export function* watchPickupRateData() {
    yield takeLatest(FETCH_PICKUP_RATE_REQUEST, pickupRateWorker);
}
